
// Jauge solaire dans chaque jour du calendrier d'archive, à partir du data-* day-length (heures)
// posé server-side par le contributeur soleil (Orekit). Un DEMI-CERCLE sous le soleil = les 24h
// (180°) ; la portion LUMINEUSE (dorée), centrée sur midi (le sommet), a une largeur = durée du
// jour ; les NUITS (sombres) occupent les extrémités. Équinoxe (12h) → 25% sombre · 50% jour · 25%
// sombre. Été → grande portion dorée ; hiver → petite calotte dorée entourée de nuit.
// Aucun calcul astro côté client : le canvas ne fait qu'hydrater.
class SunArcRenderer {
    constructor(canvas) {
        this.canvas = canvas;
        this.ctx = canvas.getContext('2d');
        this.w = canvas.width;
        this.h = canvas.height;
    }

    render({ dayLength = 12 }) {
        const ctx = this.ctx;
        ctx.clearRect(0, 0, this.w, this.h);

        const cx = this.w / 2;
        const cy = 10;                                // centre = le soleil
        const sunR = 4;
        const r = 12;                                 // jauge concentrique, rayon > soleil

        // Demi-cercle INFÉRIEUR concentrique au soleil (angles 0 → π) : les 24h. Le bas (π/2) = midi.
        const NOON = Math.PI / 2;
        const frac = Math.min(1, Math.max(0, dayLength / 24));
        const half = (frac * Math.PI) / 2;            // demi-largeur angulaire du jour

        ctx.lineCap = 'round';

        // Canvas colours, so out of the stylesheet's reach — the kawaii palette lives here
        // (cf. sky-chart/core/constants.js, same reason). Night in lilac, day in honey,
        // the sun itself in fox: the theme's own three, and the pair that _astro.scss
        // already gives the calendar's moon and sun markers.

        // Nuit : tout le demi-cercle, sombre.
        ctx.beginPath();
        ctx.arc(cx, cy, r, 0, Math.PI);
        ctx.strokeStyle = 'rgba(143, 122, 196, 0.30)';  // lilac, deep
        ctx.lineWidth = 3.4;
        ctx.stroke();

        // Jour : portion dorée centrée sur midi (le bas), largeur ∝ durée du jour.
        ctx.beginPath();
        ctx.arc(cx, cy, r, NOON - half, NOON + half);
        ctx.strokeStyle = 'rgba(255, 198, 92, 0.95)';   // honey
        ctx.lineWidth = 3.4;
        ctx.stroke();

        // Soleil au centre.
        const glow = ctx.createRadialGradient(cx, cy, 0, cx, cy, sunR * 2.3);
        glow.addColorStop(0, '#ffe9bd');
        glow.addColorStop(0.5, '#ffc65c');
        glow.addColorStop(1, 'rgba(255, 198, 92, 0)');
        ctx.beginPath();
        ctx.arc(cx, cy, sunR * 2.3, 0, Math.PI * 2);
        ctx.fillStyle = glow;
        ctx.fill();
        ctx.beginPath();
        ctx.arc(cx, cy, sunR, 0, Math.PI * 2);
        ctx.fillStyle = '#ff6b35';  // fox
        ctx.fill();
    }
}

function formatDayLength(dayLength) {
    let h = Math.floor(dayLength);
    let m = Math.round((dayLength - h) * 60);
    if (m === 60) { h += 1; m = 0; }
    return h + 'h' + String(m).padStart(2, '0');
}

function renderSunInto(host) {
    const dayLength = parseFloat(host.dataset.dayLength || 12);

    const canvas = document.createElement('canvas');
    canvas.className = 'sun';
    canvas.width = 30;
    canvas.height = 24;
    new SunArcRenderer(canvas).render({ dayLength });
    host.appendChild(canvas);

    // L'arc varie peu d'un jour à l'autre (le soleil change lentement) : le label donne la valeur.
    const label = document.createElement('span');
    label.className = 'label';
    label.textContent = formatDayLength(dayLength);
    host.appendChild(label);
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ui-calendar-day .plugin.sun').forEach(div => renderSunInto(div));
});
